module.exports = __webpack_public_path__ + "static/media/reczeeblue.6b59f8cb.svg";